import styled from '@emotion/styled';
import { tag1Sb } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

// #D4EAFF와 #2998FF 사이의 중간 색상들을 생성 (opacity 0.5 적용)
const lightColor = '#D4EAFF80';
const darkColor = '#2998FF80';

const rotateGradient = `
  @keyframes rotateGradient {
    0% { background: conic-gradient(from 0deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }

    6.25% { background: conic-gradient(from 22.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }

    12.5% { background: conic-gradient(from 45deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }

    18.75% { background: conic-gradient(from 67.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }

    25% { background: conic-gradient(from 90deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    31.25% { background: conic-gradient(from 112.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    37.5% { background: conic-gradient(from 135deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    43.75% { background: conic-gradient(from 157.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    50% { background: conic-gradient(from 180deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    56.25% { background: conic-gradient(from 202.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    62.5% { background: conic-gradient(from 225deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    68.75% { background: conic-gradient(from 247.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    75% { background: conic-gradient(from 270deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    81.25% { background: conic-gradient(from 292.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    87.5% { background: conic-gradient(from 315deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    93.75% { background: conic-gradient(from 337.5deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
    
    100% { background: conic-gradient(from 360deg, ${lightColor} 0%, ${lightColor} 45%, #8AC7FF80 55%, #5BB0FF80 65%, ${darkColor} 75%, #5BB0FF80 85%, #8AC7FF80 95%, ${lightColor} 100%); }
  }
`;

export const RotateGradientBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  border-radius: 12px;
  padding: 12px;
  position: relative;
  background: ${vars.neutral[90]};
  cursor: pointer;

  ${tag1Sb};
  color: ${vars.text.primary} !important;

  /* 테두리를 따라 움직이는 그라디언트 효과 */
  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 12px;
    padding: 1px;
    background: conic-gradient(
      from 0deg,
      ${lightColor} 0%,
      ${lightColor} 45%,
      #8ac7ff80 55%,
      #5bb0ff80 65%,
      ${darkColor} 75%,
      #5bb0ff80 85%,
      #8ac7ff80 95%,
      ${lightColor} 100%
    );
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;

    -webkit-mask-composite: xor;
    animation: rotateGradient 1.4s linear infinite;
  }

  ${rotateGradient}

  span {
    color: ${vars.blue[30]};
  }

  ${DESKTOP} {
    width: 100%;
  }
`;

export const ToolTipTriangle = styled.div`
  transform: translate(-10px, 9px);
`;
